import type { ReactNode } from 'react';
import { cn } from '@herit-fe/heritage-ui';

/**
 * 정보 행 리스트(`dl`) — `InfoRow` 들을 **행마다 하단 보더**로 끊어 세로로 쌓는다. 수익 상세시트
 * (`RevenueDetailSheet`)의 행 리스트 디자인을 공용 컴포넌트로 승격한 것.
 *
 * 보더는 각 행(`InfoRow`)이 `border-b … last:border-0` 으로 직접 그린다 — `divide-y` 를 쓰면 조건부 렌더
 * (`{cond ? <InfoRow/> : null}`)로 행이 빠질 때 `:last-child` 판정이 어긋나 마지막 줄에 보더가 남는다.
 *
 * 이전의 `InfoGrid`(라벨 10rem + 값 1fr 2열 그리드)를 대체한다. 2열 그리드는 sm 미만에서 라벨/값이 세로로
 * 쌓이면서 두 줄의 무게가 비슷해져 어느 쪽이 값인지 읽히지 않았다 — 리스트는 폭과 무관하게 좌=라벨/우=값이
 * 고정된다.
 */
export function InfoList({ children, className }: { children: ReactNode; className?: string }) {
  return <dl className={cn('flex flex-col', className)}>{children}</dl>;
}
